export const calculatePageSegment = pageCount => (pageCount <= 10 ? 0 : 9);
